module.exports = __webpack_public_path__ + "img/official_accounts.b38be775.png";